import stoneCircleAsset from "@assets/terrain/stoneCircle.fbx";

export const TerrainAssetMap = {
  stoneCircle: {
    fileName: stoneCircleAsset,
  },
} as const;
